export default __webpack_public_path__ + "static/media/clipart1877735.9513a0d9.png";